export default "__VITE_ASSET__TdJlcpqP__"